import Core from 'src/Core'
import { generateUUID, getUuid } from 'src/initializers/Utils'
import { PublicError } from 'src/Error'
import { BATCH_IS_BEING_SENT, BATCH_IS_ALREADY_SENT } from 'src/ErrorCodes'

export default class BatchUploader {
  constructor () {
    this._uuid = generateUUID()
    this._receiptUuids = []
    this._cancelledUuids = []
    this._sending = false
    this._sent = false
  }

  add (file, { onProgress }) {
    const capturedAt = new Date()
    const user = Core.getRessource('User')
    const uuid = getUuid({ capturedAt, userId: user.get('id') })
    this._receiptUuids.push(uuid)

    return {
      uuid,
      promise: Core.execute('Api', 'uploadSubpicture',
        { uuid, capturedAt, files: [file], batchUuid: this._uuid, onProgress })
    }
  }

  cancel (uuid) {
    const index = this._receiptUuids.indexOf(uuid)
    if (index === -1) {
      const mess = 'uuid "' + uuid + '" is not present in the batch'
      Core.throwInvalidParameter(mess, { parameter: 'uuid', reason: 'blank' })
    } else {
      this._receiptUuids.splice(index, 1)
      this._cancelledUuids.push(uuid)
    }
  }

  send () {
    if (this._sending) {
      return Promise.reject(new PublicError(BATCH_IS_BEING_SENT, 'this batch is being sent'))
    }
    if (this._sent) {
      return Promise.reject(new PublicError(BATCH_IS_ALREADY_SENT,
        'this batch has already been sent, ask for another one with getBatchUploader'))
    }
    this._sending = true
    return Core.execute('Api', 'sendBatch', {
      batchUuid: this._uuid,
      receiptUuids: this._receiptUuids,
      cancelledUuids: this._cancelledUuids,
      createReceipts: true,
    }).then(
      (res) => {
        this._sending = false
        this._sent = true
        return res
      },
      (err) => {
        this._sending = false
        return Promise.reject(err)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/ressources/BatchUploader.js